import qs from 'qs';
import axios from 'axios';
import { CLIENT_CREDENTIALS } from '../../interfaces.constants';

export const redirectToAuth = (userLink: string, codeChallenge: string | null) => {
  window.open(
    `${userLink}/connect/authorize?${qs.stringify({
      response_type: 'code',
      client_id: CLIENT_CREDENTIALS.CLIENT_ID,
      redirect_uri: 'https://plantafel.planwerk.app',
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      scope: 'adresse-extern termin-extern vorgang-extern',
    })}`,
    '_blank'
  );
};

export const getKwpTokenFromAPI = (code: string, userLink: string, codeVerifier: string) => {
  axios
    .post(
      `${userLink}/connect/token`,
      qs.stringify({
        grant_type: 'authorization_code',
        code,
        client_id: CLIENT_CREDENTIALS.CLIENT_ID,
        redirect_uri: 'https://plantafel.planwerk.app',
        code_verifier: codeVerifier,
        client_secret: CLIENT_CREDENTIALS.CLIENT_SECRET,
      })
    )
    .then(({ data }) => setKwpAccessToken(data?.access_token))
    .catch(err => console.log('Cannot get kwpAccessToken', err));
};

export const setKwpAccessToken = (token: string) => {
  localStorage.setItem('kwpToken', token);
};

export const getKwpAccessToken = () => {
  const token = localStorage.getItem('kwpToken');
  return token;
};
